import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { ControlEffWidgetDataModel } from "../shared/models/ControlEffWidgetDataModel";
import { DesignImplementationDashboardModel } from "../shared/models/DesignImplementationDashboardModel";
import { Observable } from "rxjs";

@Injectable()
export class ControlsWidgetsDataService extends ApiDataService {
    constructor() {
        super("controls");
    }

    public getEffectivenessWidgetInfo(filters: any) {
        const url = `/testing/simple/effectiveness/widgets/info`;
        return this.post<ControlEffWidgetDataModel[]>(filters, url);
    }

    public getDesignImplementationWidgetInfo(filters: any) {
        const url = `/testing/simple/designimplementation/widgets/info`;
        return this.post<DesignImplementationDashboardModel[]>(filters, url);
    }

    public getSimpleOverdueWidgetInfo(filters: any) {
        const url = `/testing/simple/widgets/overdue`;
        return this.post<ControlEffWidgetDataModel[]>(filters, url);
    }

    public getOverdueEffectivenessForWidget(
        filters: object
    ): Observable<ControlEffWidgetDataModel[]> {
        const url = `/testing/advanced/effectiveness/widgets/overdue`;

        return this.post<ControlEffWidgetDataModel[]>(filters, url);
    }
}
